import { Injectable } from '@angular/core';
import { AjaxHelper } from '../helper/ajax.helper';
import { Observable } from 'rxjs';
import { BaseResponse } from '../model/base.response';
import { environment } from 'src/environments/environment';
import { WebConstants } from '../util/web.constants';

@Injectable({
  providedIn: 'root'
})
export class PaymentTestingService {

  public baseUrl: string = environment.BaseServiceUrl;

  constructor(public ajaxHelper: AjaxHelper) { }

  addLPNPayment(payload : any): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.PAYMENT_TESTING.ADD_LPN_PAYMENT;

    return this.ajaxHelper.post(url , payload);
  }

  getAllLPNPaymentList(): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.PAYMENT_TESTING.FIND_ALL_LPN_PAYMENT;
    return this.ajaxHelper.get(url);
  }

  addMultipleLPNPaymentList(payload : any): Observable<BaseResponse<any>> {
    let url = this.baseUrl + WebConstants.API_URL.PAYMENT_TESTING.ADD_MULTIPLE_LPN_PAYMENT;

    return this.ajaxHelper.post(url , payload);
  }
  
}
